import { ReactElement } from 'react';
import { DashboardContainer } from '../../../../modules/common/dashboard/DashboardContainer';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { JobHeaderContainer } from '../../../../modules/jobs/containers/details/JobHeader.container';
import { JobTabsContainer } from '../../../../modules/jobs/containers/details/JobTabs.container';
import { JOB_TYPE } from '../../../../modules/jobs/jobs.model';
import { TrainingDetailsCreateRoute, TrainingDetailsRoute } from '../../../routes/trainings/trainingDetails.route';

export const TrainingDetailsView = (): ReactElement => {
  return (
    <DashboardContainer>
      <JobHeaderContainer jobType={JOB_TYPE.TRAINING} />
      <ColumnLayout size='none'>
        <JobTabsContainer />
        <TrainingDetailsRoute />
      </ColumnLayout>
    </DashboardContainer>
  );
};

export const TrainingDetailsCreateView = (): ReactElement => {
  return (
    <DashboardContainer>
      <JobHeaderContainer jobType={JOB_TYPE.TRAINING} />
      <ColumnLayout size='none'>
        <JobTabsContainer />
        <TrainingDetailsCreateRoute />
      </ColumnLayout>
    </DashboardContainer>
  );
};
